import { createTheme as y } from "@mui/material";
import { deprecatedTheme as l } from "./deprecatedTheme.mjs";
import { compileNovaTokens as d } from "./compileNovaTokens.mjs";
import { componentsCustomized as f } from "./index307.mjs";
import { zIndex as k } from "./zIndex.mjs";
import { addCompatibilityMode as T } from "./addCompatibilityMode.mjs";
import { compileTypographyWithBreakpoints as g } from "./compileTypographyWithBreakpoints.mjs";
const F = 16, S = 16, u = 0.1, R = ({
  colorMode: n = "dark",
  variant: a = "default",
  isCompatibilityMode: r,
  themeOuter: i
}) => {
  const t = d(a), m = t.dark.palette, s = t.light.palette, p = n === "dark" ? m : s, { typography: c, ...e } = t.tokens, h = {
    palette: {
      mode: n,
      ...p,
      action: {
        ...p.action,
        hoverOpacity: u
      }
    },
    tokens: e,
    typography: g(c),
    components: f,
    shadows: e.elevation,
    Shadows: e.Shadows,
    FocusRing: e.FocusRing,
    zIndex: k,
    /**
     * Available for backwards compatibility with old theme only. Doesn't contain any values
     * @deprecated
     */
    colors: {}
  }, o = y(
    h,
    l,
    i || {}
  );
  return r && T(o), o.typography.fontFamily = t.tokens.fontFamilies.inter, o.typography.htmlFontSize = F, o.typography.fontSize = S, o;
};
export {
  R as compileTheme
};
//# sourceMappingURL=compileTheme.mjs.map
